var $class="se2--header-se--geolocation-banner",$name="HeaderSE/geolocationBanner",$path="app/components/HeaderSE/partials/geolocationBanner/config.js",$this={$class,$name,$path,};export const acceptButtonSelector = '.button-accept';
export const closeBannerButtonSelector = '.button-close';
export const geolocationBannerClassName = $class;
export const openCountrySelectorButtonSelector = '.button-choose';
